import Vue from 'vue'
import store from '@/store'
import model from './mobileModal'
import axios from './http'
import { handleJson } from './filter'

// 获取埋点上报接口
export const getTrackUrl =() => {
  return new Promise((resolve, reject) => {
    axios.get(process.env.API_ROOT+'/marketOrder/getParam?key=ZMP_POINT_URL')
      .then(({ data }) => {
          if(data.code == 0){
              resolve(data.config && data.config.paramValue)
          }else {
              resolve('')
          }
      })
  });
}

export const handleTrackParams = (data = null)=>{
	console.log('会话Id全局：',sessionStorage.getItem('mifiVisitorId'));
  let connectionObj = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {type: 'unknown'}
  let obj = {
    deviceNo: store.state.user.sim || '', // 设备号
    deviceId: store.state.user.iccid || '', // 设备id
    openId: sessionStorage.getItem('authOpenId') || '', // 用户openId
    mobile: store.state.user.mobile || '', // 手机号
    browser: store.state.user.deviceType || '', // 浏览器
    netEnv: connectionObj.effectiveType || connectionObj.type,  // 网络环境
    deviceModel: model, // 设备型号
    traceId: sessionStorage.getItem('mifiVisitorId') || '', // traceId(会话标识)  
    beforeRoute: sessionStorage.getItem('mifiBeforeRoute'), // 上一页面
    iccidInAgentName: sessionStorage.getItem('iccidInAgentName') || '', // 代理名称
    orderPackages: store.state.user.orderPackages || undefined, // 是否有套餐 0：没有  1：有
  }
  if(data){
    obj = Object.assign({},obj,data)
  }
  return obj;
}

// 发起上报调用接口
export const trackSubmit = async (params=null,isScanCodeTrack=false)=>{
  let isTrack = sessionStorage.getItem('buriedStatus') || isScanCodeTrack || false;
  if(!isTrack || isTrack == 'false') return; // 入口关闭为不上报
  let url = sessionStorage.getItem('trackUrl') || ''
  if(!url){
    url = await getTrackUrl();
    sessionStorage.setItem('trackUrl',url)
  }
  params = handleTrackParams(params)
  console.log(params)
  console.log('获取参数----发起上报')
  axios.post(url,params).then((res)=>{
    if(res.status == 200){
      console.info('上报成功')
    }else {
      console.error('上报失败')
    } 
  })
}


// 全局监听点击事件
export const ListenerFn = ()=>{
  window.addEventListener('click',(e)=>{
    if(e.target){
      let el = e.target
      let clickParams = ''
      if(el.dataset && el.dataset.click){
        clickParams = el.dataset.click
      }else if(el.parentNode && el.parentNode.dataset.click){
        clickParams = el.parentNode.dataset.click
      }else {
        clickParams = ''
      }
      if(clickParams){
        trackSubmit(handleJson(2,clickParams))
      }
    }
  })
}


// export default track;


// WEBPACK FOOTER //
// ./src/utils/track.js